import { getMembershipStatus, getStatusTone, formatStatus, formatCancelledDate, MEMBERSHIP_DISPLAY_STATUS } from '@/utils';
import { Badge } from '@/components/ui';
import { useDateFormat } from '@/hooks';
import { MembershipStatusProps } from '@/types/component-props';

export default function MembershipStatusCell({ membership, className, isUnavailable }: MembershipStatusProps) {
  const { formatDateRange } = useDateFormat();

  // A failed fetch must never be rendered as a confirmed absence of coverage.
  if (isUnavailable && !membership) {
    return (
      <span className={`text-amber-700 ${className ?? ''}`.trim()}>
        Membership unavailable
      </span>
    );
  }

  if (!membership) {
    return <span className={className}>No Membership</span>;
  }

  // Pure live calculation - always accurate and consistent
  // Now includes status field for cancelled detection
  const displayStatus = getMembershipStatus({
    start_date: membership.start_date,
    end_date: membership.end_date,
    status: membership.status,
  });

  const statusTone = getStatusTone(displayStatus);
  const statusText = formatStatus(displayStatus);

  return (
    <div>
      <div className="mb-1">
        <Badge tone={statusTone}>
          {statusText}
        </Badge>
      </div>
      <div className="text-sm font-medium text-gray-900 mb-1">{membership.name}</div>
      <div className="text-xs text-gray-500">
        {formatDateRange(membership.start_date, membership.end_date)}
      </div>
      {displayStatus === MEMBERSHIP_DISPLAY_STATUS.CANCELLED && membership.cancelled_at && (
        <div className="text-xs text-gray-400 mt-1">
          {formatCancelledDate(membership.cancelled_at)}
        </div>
      )}
    </div>
  );
} 